import { Text, VStack } from '@talos/kyoko';

export const NO_MOBILE_FRIENDLY_PANELS_TITLE = 'No mobile-friendly content';
export const NO_MOBILE_FRIENDLY_PANELS_MESSAGE =
  'This space does not contain any panels that are available on mobile yet.';

interface TradingPlaceholderProps {
  label: string;
  message?: string;
}

/**
 * Temporary body used while mobile panel content is not yet implemented. Reserves space matching a real
 * panel (safe-area insets, tall scroll area) so the tab bar behaves the same as in the real flow.
 */
export function TradingPlaceholder({ label, message }: TradingPlaceholderProps) {
  return (
    <VStack
      data-testid="mobile-trading-placeholder"
      h="100dvh"
      background="backgroundContent"
      mb="env(safe-area-inset-bottom)"
      flex="1 0 auto"
      pt="env(safe-area-inset-top)"
      gap="spacing8"
      p="spacing24"
      textAlign="center"
    >
      <Text as="h1" color="colorTextImportant" fontSize="fontSizeXl" fontWeight={500} m={0}>
        {label}
      </Text>
      {message != null && (
        <Text color="colorTextSubtle" fontSize="fontSizeMd">
          {message}
        </Text>
      )}
    </VStack>
  );
}
